module.exports = __webpack_public_path__ + "media/images/site-section/icons/view-28d0447d551af54ecbef5764dfb64030.svg";